import MuiPagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import styled from "styled-components";

export const Container = styled(Stack)`
	font-size: 1rem;
	margin-top: 0.75em;
`;

export const StyledPagination = styled(MuiPagination)`
	display: flex;
	justify-content: center;

	.MuiPagination-ul {
		justify-content: center;
		align-items: center;
		flex-wrap: nowrap;
		gap: 0.1em;
	}

	.MuiPaginationItem-root {
		min-width: 2em;
		height: 2em;
		margin: 0;
		border: none;
		font-weight: 700;
		font-size: 1em;
		color: #1f3b66;
	}

	.MuiPaginationItem-page {
		min-width: 1.75em;
		height: 1.75em;
		font-size: 0.95em;
	}

	.MuiPaginationItem-root.Mui-selected {
		background-color: #1f3b66;
		color: #fff;
	}

	.MuiPaginationItem-root.Mui-selected:hover {
		background-color: #1f3b66;
	}

	.MuiPaginationItem-previousNext {
		color: #6e6e6e;
	}

	.MuiPaginationItem-ellipsis {
		color: #1f3b66;
	}
`;
